import {
  AccountDetailResponse,
  accountsContract,
} from "@clipboard-health/contract-payment-service";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api/useGetQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

// To avoid unnecessary refetches, we increase stale time to 30s
const STALE_TIME_30_SECONDS = 30 * 1000;

// This endpoint calls Stripe under the hood and is expected to respond slowly.
// Used for polling account status updates during onboarding.
export function useGetPaymentServiceAccount(
  options: UseGetQueryOptions<AccountDetailResponse> = {}
) {
  const { userId: workerId } = useDefinedWorker();

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${workerId}`,
    responseSchema: accountsContract.getById.responses[200],
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_PAYMENT_SERVICE_ACCOUNT_FAILURE,
    },
    ...options,
    staleTime: options?.staleTime ?? STALE_TIME_30_SECONDS,
  });
}
